module.exports = __webpack_public_path__ + "static/25-img-1-25d4a9a75a4e93c2c45cdaacc579df57.png";